import {
  SET_SUPPORT_CHAT_MODULE_TAGS,
  SUPPORT_CHAT_MODULE_TAGS_LOADING,
  SUPPORT_CHAT_MODULE_TAG_UPDATING,
} from '../actions/supportChatModuleTagsAction';

const initialState = {
  supportChatModuleTags: [],
  supportChatModuleTagsLoading: false,
  supportChatModuleTagUpdating: false,
};

export default function supportChatModuleTagsReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case SET_SUPPORT_CHAT_MODULE_TAGS:
      return {
        ...state,
        supportChatModuleTags: action.data,
      };
    case SUPPORT_CHAT_MODULE_TAGS_LOADING:
      return {
        ...state,
        supportChatModuleTagsLoading: action.data,
      };
    case SUPPORT_CHAT_MODULE_TAG_UPDATING:
      return {
        ...state,
        supportChatModuleTagUpdating: action.data,
      };
    default:
      return state;
  }
}
